// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"Table-tableContainer-2VRGN","horizontalScroll":"Table-horizontalScroll-2nLbD","table":"Table-table-2C3O8"};